export interface NavLink {
  label: string;
  to: string;
  /** Marks the link active for any nested route, not just an exact match. */
  matchPrefix?: boolean;
}

/** Primary navigation — rendered in the header, mobile menu and footer. */
export const NAV_LINKS: NavLink[] = [
  { label: 'Início', to: '/' },
  { label: 'Cães', to: '/catalogo?pet=dog' },
  { label: 'Gatos', to: '/catalogo?pet=cat' },
  { label: 'Marcas', to: '/marcas', matchPrefix: true },
  { label: 'Como comprar', to: '/como-comprar' },
  { label: 'Contato', to: '/contato' },
];

export const FOOTER_LINKS = {
  catalogo: [
    { label: 'Catálogo completo', to: '/catalogo' },
    { label: 'Rações para cães', to: '/catalogo?pet=dog' },
    { label: 'Rações para gatos', to: '/catalogo?pet=cat' },
    { label: 'Super premium', to: '/catalogo?line=super-premium' },
    { label: 'Sachês e úmidos', to: '/catalogo?type=wet' },
    { label: 'Petiscos', to: '/catalogo?type=treat' },
  ],
  institucional: [
    { label: 'Marcas que trabalhamos', to: '/marcas' },
    { label: 'Como comprar', to: '/como-comprar' },
    { label: 'Contato', to: '/contato' },
    { label: 'Favoritos', to: '/favoritos' },
    { label: 'Política de privacidade', to: '/privacidade' },
    { label: 'Termos de uso', to: '/termos' },
  ],
} as const;
